export const contactSection = {
  inputs: [
    {
      name: "username",
      type: "text",
      placeholder: "Your Name",
      required: true,
    },
    {
      name: "email",
      type: "email",
      placeholder: "Email Address",
      required: true,
    },
    {
      name: "phone",
      type: "text",
      placeholder: "Phone Number",
      required: true,
    },
    {
      name: "subject",
      type: "text",
      placeholder: "Subject",
      required: true,
    },
    {
      name: "message",
      placeholder: "Write Message",
      required: true,
    },
  ],
  title: "Offices near you",
  contacts: [
    {
      id: 1,
      name: "Austin",
      address: "22 Texas West Hills",
      email: "ashhad.k2@gmail.com",
      phone: "0315-2920819",
    },
    {
      id: 2,
      name: "Boston",
      address: "5 Federal Street Boston",
      email: "ashhad.k2@gmail.com",
      phone: "0315-2920819",
    },
    {
      id: 3,
      name: "New york",
      address: "8th Broklyn New York",
      email: "ashhad.k2@gmail.com",
      phone: "0315-2920819",
    },
    {
      id: 4,
      name: "baltimore",
      address: "3 Lombabr 50 Baltimore",
      email: "ashhad.k2@gmail.com",
      phone: "0315-2920819",
    },
  ],
};

export const contactSectionTwo = {
  title: "Write us any message",
  text: "Have a project in mind or need help bringing your ideas to life? Feel free to reach out and share your requirements. I’d love to hear from you and discuss how I can help turn your vision into a modern, functional digital experience.",
  socials: [
    "fab fa-twitter",
    "fab fa-facebook",
    "fab fa-pinterest-p",
    "fab fa-instagram",
  ],
};

export const contactInfoTwo = [
  {
    id: 1,
    icon: "fa fa-map-marker-alt",
    text: "66 Broklyn Street, USA",
  },
  {
    id: 2,
    icon: "fa fa-envelope",
    text: "ashhad.k2@gmail.com",
    email: true,
  },
  {
    id: 3,
    icon: "fa fa-phone",
    text: "+92-315-2920819",
    phone: true,
  },
];
